import { gsap } from "gsap";
import { onReady } from "../core/swup.js";

let cleanupSticky = null;

function initStickyMenu() {
    if (cleanupSticky) {
        cleanupSticky();
    }

    const header = document.querySelector('.page-header');
    if (!header) {
        cleanupSticky = null;
        return;
    }

    let isSticky = false;
    let threshold = window.innerHeight / 3;
    let ticking = false;

    function showHeader() {
        if (!isSticky) {
            header.classList.add('sticky');
            gsap.fromTo(
                header,
                { y: -100, opacity: 0 },
                { y: 0, opacity: 1, duration: 0.5, ease: "power2.out" }
            );
            isSticky = true;
        }
    }

    function hideHeader() {
        if (isSticky) {
            gsap.to(header, {
                y: 0,
                opacity: 1,
                duration: 0.5,
                ease: "power2.in",
                onComplete: () => {
                    header.classList.remove('sticky');
                }
            });
            isSticky = false;
        }
    }

    function handleScroll() {
        const scrollY = window.scrollY;
        if (scrollY > threshold) {
            showHeader();
        } else {
            hideHeader();
        }
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
            handleScroll();
            ticking = false;
        });
    }

    function onResize() {
        threshold = window.innerHeight / 3;
        handleScroll();
    }

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);
    handleScroll();

    cleanupSticky = () => {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
        gsap.killTweensOf(header);
        header.classList.remove('sticky');
    };
}

onReady(initStickyMenu);
